module.exports = __webpack_public_path__ + "img/nacional-24h.17331632.png";